import { BankAccountStatementRequestType } from '../../types/BankAccountStatementRequest';

export const typesMap: Record<BankAccountStatementRequestType, string> = {
  [BankAccountStatementRequestType.EndOfYearBalance]: 'End of year balance',
  [BankAccountStatementRequestType.StartOfYearBalance]: 'Start of year balance',
  [BankAccountStatementRequestType.TransactionsBackfill]: 'Transactions backfill',
};
